module.exports = __webpack_public_path__ + "static/media/sandals.f4cb7115.svg";